export default __webpack_public_path__ + "static/media/7_PenseEncoreToi.eca98535.mp3";